import React, { Component } from 'react';
import { ErrorPageMessage } from 'Components/ErrorPageMessage/ErrorPageMessage';
import { logger } from 'Utils/Logger';

export class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    const { name = 'error boundary' } = this.props;
    logger.error(name, null, error);
    this.setState({
      hasError: true,
      error,
      info,
    });
  }

  render() {
    const { hasError, error, info } = this.state;
    const { message: ErrorMessage = ErrorPageMessage, children } = this.props;

    if (hasError && ErrorMessage) {
      return <ErrorMessage error={error} info={info} />;
    }
    return children;
  }
}
